import React, { Fragment } from "react";
import { isNullOrUndefined } from "util";

export interface ILoadingIndicatorProperties {
    text?: string;
    isLoading: boolean;
}

/**
 * Displays loading spinner when the isLoading property is set to true.
 * @param props Specify whether data is loading and the text to display.
 */
const LoadingIndicator: React.FC<ILoadingIndicatorProperties> = (props) => {
    // Use a default message if none provided.
    const message: string = `${isNullOrUndefined(props.text) ? "Loading" : props.text}...`;

    function loadingContent(): JSX.Element | null {
        if (!props.isLoading) {
            return null;
        }

        return (
            <div className="col-md-12 loading-indicator">
                <div className="d-flex justify-content-center">
                    <div className="spinner-border text-dark" role="status">
                        <span className="sr-only">{message}</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center spinner-text">{message}</div>
            </div>
        );
    }

    return (
        <Fragment>
            {loadingContent()}
        </Fragment>
    );
}

export default LoadingIndicator;
